import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=75aa855e&"
import script from "./error-404.vue?vue&type=script&lang=ts&"
export * from "./error-404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports